"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPropertyDetailsPropertiesStreetGroupPropertyIdGetRequest$ = exports.GetPropertyDetailsPropertiesStreetGroupPropertyIdGetRequest$outboundSchema = exports.GetPropertyDetailsPropertiesStreetGroupPropertyIdGetRequest$inboundSchema = exports.GetPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurity$ = exports.GetPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurity$outboundSchema = exports.GetPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurity$inboundSchema = void 0;
exports.getPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurityToJSON = getPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurityToJSON;
exports.getPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurityFromJSON = getPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurityFromJSON;
exports.getPropertyDetailsPropertiesStreetGroupPropertyIdGetRequestToJSON = getPropertyDetailsPropertiesStreetGroupPropertyIdGetRequestToJSON;
exports.getPropertyDetailsPropertiesStreetGroupPropertyIdGetRequestFromJSON = getPropertyDetailsPropertiesStreetGroupPropertyIdGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const shared = __importStar(require("../shared/index.js"));
/** @internal */
exports.GetPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurity$;
(function (GetPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurity$) {
    /** @deprecated use `GetPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurity$inboundSchema` instead. */
    GetPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurity$.inboundSchema = exports.GetPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurity$inboundSchema;
    /** @deprecated use `GetPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurity$outboundSchema` instead. */
    GetPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurity$.outboundSchema = exports.GetPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurity$outboundSchema;
})(GetPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurity$ || (exports.GetPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurity$ = GetPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurity$ = {}));
function getPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurityToJSON(getPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurity) {
    return JSON.stringify(exports.GetPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurity$outboundSchema
        .parse(getPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurity));
}
function getPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetPropertyDetailsPropertiesStreetGroupPropertyIdGetSecurity' from JSON`);
}
/** @internal */
exports.GetPropertyDetailsPropertiesStreetGroupPropertyIdGetRequest$inboundSchema = z.object({
    "fields[property]": z.array(shared.PropertyUserFields$inboundSchema),
    street_group_property_id: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "fields[property]": "fieldsProperty",
        "street_group_property_id": "streetGroupPropertyId",
    });
});
/** @internal */
exports.GetPropertyDetailsPropertiesStreetGroupPropertyIdGetRequest$outboundSchema = z.object({
    fieldsProperty: z.array(shared.PropertyUserFields$outboundSchema),
    streetGroupPropertyId: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        fieldsProperty: "fields[property]",
        streetGroupPropertyId: "street_group_property_id",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPropertyDetailsPropertiesStreetGroupPropertyIdGetRequest$;
(function (GetPropertyDetailsPropertiesStreetGroupPropertyIdGetRequest$) {
    /** @deprecated use `GetPropertyDetailsPropertiesStreetGroupPropertyIdGetRequest$inboundSchema` instead. */
    GetPropertyDetailsPropertiesStreetGroupPropertyIdGetRequest$.inboundSchema = exports.GetPropertyDetailsPropertiesStreetGroupPropertyIdGetRequest$inboundSchema;
    /** @deprecated use `GetPropertyDetailsPropertiesStreetGroupPropertyIdGetRequest$outboundSchema` instead. */
    GetPropertyDetailsPropertiesStreetGroupPropertyIdGetRequest$.outboundSchema = exports.GetPropertyDetailsPropertiesStreetGroupPropertyIdGetRequest$outboundSchema;
})(GetPropertyDetailsPropertiesStreetGroupPropertyIdGetRequest$ || (exports.GetPropertyDetailsPropertiesStreetGroupPropertyIdGetRequest$ = GetPropertyDetailsPropertiesStreetGroupPropertyIdGetRequest$ = {}));
function getPropertyDetailsPropertiesStreetGroupPropertyIdGetRequestToJSON(getPropertyDetailsPropertiesStreetGroupPropertyIdGetRequest) {
    return JSON.stringify(exports.GetPropertyDetailsPropertiesStreetGroupPropertyIdGetRequest$outboundSchema
        .parse(getPropertyDetailsPropertiesStreetGroupPropertyIdGetRequest));
}
function getPropertyDetailsPropertiesStreetGroupPropertyIdGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPropertyDetailsPropertiesStreetGroupPropertyIdGetRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetPropertyDetailsPropertiesStreetGroupPropertyIdGetRequest' from JSON`);
}
//# sourceMappingURL=getpropertydetailspropertiesstreetgrouppropertyidget.js.map